import { render, staticRenderFns } from "./ButtonFormRoles.vue?vue&type=template&id=ea82625a&"
import script from "./ButtonFormRoles.vue?vue&type=script&lang=js&"
export * from "./ButtonFormRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports